var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgForwardIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-next",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.59 26.59",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.icon-next .st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.97,12.61L16.67,0.48c-0.15-0.12-0.34-0.18-0.52-0.18c-0.13,0-0.25,0.03-0.37,0.09 c-0.29,0.15-0.48,0.45-0.48,0.78v10.12L1.67,0.48C1.52,0.36,1.33,0.3,1.15,0.3c-0.13,0-0.25,0.03-0.37,0.09 C0.48,0.53,0.3,0.83,0.3,1.16v24.27c0,0.33,0.19,0.63,0.48,0.78c0.12,0.06,0.25,0.09,0.37,0.09c0.19,0,0.37-0.06,0.52-0.18 L15.3,15.31v10.12c0,0.33,0.19,0.63,0.48,0.78c0.12,0.06,0.25,0.09,0.37,0.09c0.19,0,0.37-0.06,0.52-0.18l15.3-12.13 c0.21-0.16,0.33-0.42,0.33-0.68S32.18,12.78,31.97,12.61z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForwardIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/forward_icon.22b05eaf.svg";
export { ForwardRef as ReactComponent };